/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Payabli/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TableX from 'DesignSystem/TableX/react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Payabli({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderCaptureMethod/Content/TestInfo/Content/Content/Payabli"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let constantData = fromHelpers.getTableData('true')
  return (<React.Fragment
>
<div
  data-testid="Payabli.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-1-12nrEF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 goTo="https://docs.payabli.com/references/test-accounts"
 text="Docs"
/>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../No'))}
 text="Close"
 size="small"
 type="secondary"
/>
</div>
<TableX
  viewPath={`${viewPath}/TableX`}
 data="'true'"
 format="helpers.js getTableData"
 value={constantData}
 marginTop={8}
 heightHeader={24}
 heightRow={24}
/>
{children}
</React.Fragment>)
}